function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgSort(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M79.328 60.505a4 4 0 00-5.656 0L61 73.177V11a4 4 0 00-8 0v72a4 4 0 004 4 3.986 3.986 0 003.393-1.904l18.935-18.935a3.997 3.997 0 000-5.656zM39.921 10.216c-.023-.113-.065-.217-.097-.327-.041-.141-.074-.283-.13-.42-.053-.128-.126-.243-.191-.364-.059-.109-.107-.221-.176-.325a3.993 3.993 0 00-.455-.557c-.016-.016-.026-.036-.043-.052-.016-.016-.035-.026-.051-.042a4.017 4.017 0 00-.559-.456c-.1-.067-.208-.113-.312-.169-.125-.068-.245-.143-.377-.198-.129-.053-.264-.084-.397-.123-.117-.035-.229-.08-.35-.104a4.024 4.024 0 00-.734-.074C36.032 7.005 36.016 7 36 7s-.032.005-.048.005a4.024 4.024 0 00-.734.074c-.121.024-.233.069-.35.104-.133.039-.268.07-.397.123-.132.055-.252.13-.377.198-.104.057-.213.103-.312.17a4.017 4.017 0 00-.559.456c-.016.016-.035.026-.051.042L13.796 27.546a4 4 0 105.658 5.657L32 20.657V83a4 4 0 008 0V11.001c0-.263-.028-.526-.079-.785z"
  }));
}

SvgSort.clsName = 'icon-www__sort';
SvgSort.remarkName = 'unknown';
export default SvgSort;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Sort.js
// module id = 2437
// module chunks = 17 18